import { t } from "i18next";
import React, {useEffect, useState} from "react";
import { RiderModel, RiderProductModel } from "../../Api/Models/rider.model";
import { ReturnStatus } from "../../Api/Models/return.model";
import {useOutletContext} from "react-router-dom";
import {RiderProfileLayoutContextInterface} from "../../Pages/Rider/RiderProfileLayout";
import {patrollerService} from "../../Api/Services/PatrollerService";
import {useUser} from "../../Context/UserProvider";
import { RingWarningIcon } from "../Icons/RingWarningIcon";
import Popover from "../Popover";
import { CalendarIcon } from "../Icons/CalendarIcon";
import { ChangeIcon } from "../Icons/ChangeIcon";

interface GearsProps {
  gears: RiderProductModel[];
  rider: RiderModel;
  subTitle?: string;
}

const Gears: React.FunctionComponent<GearsProps> = ({
  gears,
  subTitle
}) => {
  const {
    setShowProfileInfo,
      setSubTitle,
      setShowTabsNavbar,
      rider,
  } = useOutletContext<RiderProfileLayoutContextInterface>();
  const [displayAlreadyChecked, setDisplayAlreadyChecked] = useState(false);
  const [lastCheckDoneBy, setLastCheckDoneBy] = useState("");
  const {user} = useUser();

  setShowTabsNavbar(true);
  setShowProfileInfo(true);
  setSubTitle(t('Gear Owned by the Rider'));

  const getGearColor = (gear: RiderProductModel) => {
    if (gear.discontinued) {
      return "black";
    }

    if (gear.returnDate && gear.returnStatus !== ReturnStatus.MISSING) {
      return "grey";
    }

    if (!gear.exchangeDays || gear.returnStatus === ReturnStatus.MISSING) {
      return "red";
    }

    if (gear.exchangeDays <= 7) {
      return "orange";
    }

    return "green";
  };

  useEffect(() => {
    patrollerService.isRiderReadyForCheck(rider.riderId).then(() => {
    }).catch((result) => {
      setLastCheckDoneBy(result.patrollerId ?? "");
      setDisplayAlreadyChecked(true);
    });
  }, [rider]);

  return (

<>
    {subTitle && <div className="heading mb-4">{subTitle}</div>}

    <div className="">
      {(displayAlreadyChecked && user) && (
        <>
          <div className="card mb-4">
            <div className="py-2">
              <div className="flex justify-center mb-4" style={{color: "rgba(215, 179, 34, 1)"}}>
                <RingWarningIcon />
              </div>
              <p className="text-center mb-5">
                {user.id === lastCheckDoneBy ? t("You already checked this rider in the past 2 days." ) : t("This rider was already checked in the past 2 days.")}
              </p>
              <p className="text-center text-small">{t("Please look for a new rider!")}</p>
            </div>
          </div>
        </>
      )}
      {gears.length > 0 && (
        <div className="">
          {gears.map((gear, index) => (
            <React.Fragment key={index}>
               <div className="list-card mb-4">
                  <div className="flex gap-2">
                    <div className="relative">
                      <div className="list-card__image">
                        <img src={gear.productImage} alt="package name" />
                      </div>

                      {gear.variationName && (
                        <div className="list-card__variation-name">
                          {gear.variationName}
                        </div>
                      )}

                    </div>

                    <div className="flex flex-col justify-between w-full">
                      <div className="flex justify-between gap-2">
                        <div className="list-card__title">
                            {gear.productName}
                        </div>
                        <div>
                          <Popover defaultPosition={"left"} text={t("Reported by T-patroller")}>
                              <div className={"status-dot " + getGearColor(gear)}></div>
                            </Popover>
                        </div>
                      </div>
                  
                      <div className="flex justify-between gap-2">
                        <div>
                            {gear.returnDate ? (
                              <div className="flex gap-1 items-center color-secondary">
                                {/*{t("Return Date")}:*/}
                                <CalendarIcon />
                                {gear.returnDate.replaceAll('-', '/')}
                              </div>
                            ) : (
                              <div className="flex gap-1 items-center color-secondary">
                                {/*{t("Assign Date")}:&nbsp;*/}
                                <CalendarIcon />
                                {gear.assignedAt.replaceAll('-', '/')}
                              </div>
                            )}
                          </div>

                          <div>
                            {gear.discontinued ? (
                              <span className="font-8">{t("Discountinued")}</span>
                            ) : (gear?.exchangeDays ?? 0) > 0 ? (
                              <div className="list-card__status list-card__status--blue">
                                {/*{t("Days until")}*/}
                                <ChangeIcon />
                                {gear.exchangeDays} {t('day')}
                              </div>
                            ) : <div className="list-card__status list-card__status--red">
                                <ChangeIcon />
                                0 {t('day')}
                              </div>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
    </>
  );
};

export default Gears;
